module.exports = __webpack_public_path__ + "templates.dialog.member_get_coupon-db1c9388.html";